export const locale = {
  lang: 'zh1',
  data: {
    'NOTIFICACIONES': {
      'INFO': {
        'HOY': '今天',
        'TITUNOT': '通知事項',
        'NOTTTIP': '標記為已讀'
      },
      'EDITOR_EMAILS': {
        'NUEVAMOD': '<b>-ALVPRRO-</b>公司已對其一個或多個通訊電子郵件進行了修改',
        'NUEVAMODODS': '項目經理對<b>-ALVPRRO-</b>公司的一封或多封通訊電子郵件進行了更改'
      },
      'AUTORI-ENCUESTA': {
        'AUTORIZAR-ENCUESTA': '<b>-ALVPRRO-</b>公司已發送授權進行調查',
      },
    },
    'NOTIFICACION_PRODUCT':{
      'PRODUCTOS_ID':{
        '20':'認證',
        '40':'認證 3.0',
        '41':'測量 3.0',
        '42':'Pulsecheck 3.0',
        '43':'焦點區域',
        '56': 'AMCO',
        '57': '體面的工作',
        '58':'第一份工作',
        '63':'NOM-035 v3.0',
      },
      'TIPO_MENSAJE_MOSTRAR':{
        'languageNative':'您選擇了主要語言',
        'sinAdicionales':'您沒有選擇其他語言',
        'languageAdittional':'您選擇了其他語言',
        'conAdicionales':'您已取消選中沒有附加語言的檢查',
        'deleteLangNative':'您已刪除母語',
        'completePasLang':'您已完成語言步驟',
        'completePasTemplate':'您已完成模板步驟',
        'completePasReacti': '您已完成試劑步驟',
        'completePasNps': '您已完成 nps 步驟',
        'completePasControl': '您已完成控制步驟',
        'completePasDemogra': '您已完成人口統計步驟',
        'completePasAbierta': '您已完成打開步驟',
        'completePasAdicio': '您已完成附加步驟',
        'completePas4all': '您已經完成了 forall 步驟',
        'completePasEncues': '您已完成調查步驟',
        'completePasColab': '您已完成合作者步驟',
        'completePasEnvi': '您已完成發送步驟',
        'completePasEstat': '您已完成調查狀態步驟',
        'completePasProgra': '您已經完成了編程步驟',
        'DescompletePasLang': '您已完成語言步驟',
        'DescompletePasTemplate': '您已取消完成模板步驟',
        'DescompletePasReacti': '您尚未完成試劑步驟',
        'DescompletePasNps': '你已經完成了 nps 步驟',
        'DescompletePasControl': '您已取消完成控制步驟',
        'DescompletePasDemogra': '您尚未完成人口統計步驟',
        'DescompletePasAbierta': '您尚未完成打開的步驟',
        'DescompletePasAdicio': '您尚未完成附加步驟',
        'DescompletePas4all': '您尚未完成 forall 步驟',
        'DescompletePasEncues': '您尚未完成調查步驟',
        'DescompletePasColab': '您尚未完成協作者步驟',
        'DescompletePasEnvi': '您尚未完成發送步驟',
        'DescompletePasEstat': '您尚未完成調查狀態步驟',
        'DescompletePasProgra': '您尚未完成編程步驟',
        'createSurvey': '調查已創建',
        'saveUserDemo': '您已將演示用戶保存到調查中',
        'recreateSurvey': '調查已重新創建',
        'saveSeccionNps': 'nps 部分已保存到調查中',
        'saveSeccionReactivos': '試劑部分已保存到調查中',
        'saveSeccionControl': '控制部分已保存到調查中',
        'saveSeccionDemogra': '人口統計部分已保存到調查中',
        'saveSeccionAbier': '打開的部分已保存到調查中',
        'saveSeccionForall': 'Forall 部分已保存到調查中',
        'saveSeccionAdicio': '附加部分已保存到調查中',
        'subBaseColab': '貢獻者庫已上傳',
        'downloadBaseColab': '貢獻者庫已下載',
        'deleteBaseColab': '貢獻者庫已被刪除',
        'saveUsersSurvey': '調查合作者已被保存',
        'regisFechaLanza': '調查的啟動日期已被記錄',
        'regisFechaAviso1': '調查前通知 1 的日期已被記錄',
        'regisFechaAviso2': '調查前的警告 2 的日期已被記錄',
        'saveRecordatorioEncu': '已記錄提醒',
        'enviarCorreos': '您已選擇向您的合作者發送郵件',
        'noEnviarCorreos': '您已選擇不向您的合作者發送郵件',
        'cambiarEstatusCorreo': '您已進行更改以修改郵件發送',
        'ActivaEstatEncu': '調查已激活',
        'DesacEstatEncu': '調查已停用',
        'activoSeccionNps':'已為調查激活 NPS 部分',
        'desActivoSeccionNps':'NPS 部分已為調查停用',
        'activoSeccionReactivos':'REACTIVE 部分已為調查激活',
        'desActivoSeccionReactivos':'REACTIVOS 部分已為調查停用',
        'activoSeccionControl':'已為調查激活 CONTROL 部分',
        'desActivoSeccionControl':'該調查的控制部分已被停用',
        'activoSeccionDemograficos':'人口統計部分已為調查激活',
        'desActivoSeccionDemograficos':'人口統計部分已為調查停用',
        'activoSeccionAbiertas':'已為調查激活 OPEN 部分',
        'desActivoSeccionAbiertas':'ABIERTAS para la encuesta 部分已被停用',
        'activoSeccionForall':'FORALL 部分已為調查激活',
        'desActivoSeccionForall':'FORALL 部分已為調查停用',
        'activoSeccionAdicionales':'已為調查激活附加部分',
        'desActivoSeccionAdicionales':'附加部分已為調查停用',
        'deletePregTemNps':'問題已從 NPS 部分刪除',
         'deletePregTemReacti':'該問題已從 REACTIVES 部分刪除',
         'deletePregTemControl':'問題已從控制部分刪除',
         'deletePregTemDemogra':'該問題已從 DEMOGRAPHICS 部分刪除',
         'deletePregTemAbier':'問題已從 OPEN 部分刪除',
         'deletePregTemAdici':'該問題已從附加部分刪除',
         'savePregCatNps':'目錄問題已保存到 NPS 部分',
         'savePregCatReacti':'目錄問題已保存到 REAGENTS 部分',
         'savePregCatControl':'目錄問題已保存到控制部分',
         'savePregCatDemogra':'目錄問題已保存到 DEMOGRAPHICS 部分',
         'savePregCatAbier':'目錄問題已保存到 OPEN 部分',
         'savePregCatAdici':'目錄問題已保存到附加部分',
         'savePregNueNps':'新問題已保存到 NPS 部分',
         'savePregNueReacti':'新問題已保存到 REAGENTS 部分',
         'savePregNueControl':'新問題已保存到控制部分',
         'savePregNueDemogra':'新問題已保存在 DEMOGRAPHICS 部分',
         'savePregNueAbier':'新問題已保存到 OPEN 部分',
         'savePregNueAdici':'新問題已保存到附加部分',
         'editPregNps':'問題已在 NPS 部分編輯',
         'editPregReacti':'試劑部分的問題已被編輯',
         'editPregControl':'控制部分的問題已被編輯',
         'editPregDemogra':'DEMOGRAPHICS 部分的問題已被編輯',
         'editPregAbier':'OPEN 部分的問題已被編輯',
         'editPregAdici':'附加部分中的問題已被編輯',
         'LogOut':'您已註銷',
         'reiniciarLang':'您已重新啟動產品',
         'accionText':'',
         'updatCuesForall':'The questionnaire of the forall section has been updated.',
         'savePracticaForall':'練習 forall 已保存',
         'saveDescripForall':'練習 forall 已保存',

      },
      'BTN_MOSTRAR_HISTO':'顯示歷史',
      'ETI_PRODUC':'產品：',
      'TITLE_HISTO_PROD':'產品歷史',
      'CARG_INFOR':'加載信息',
      'TITLE_FILTER':'過濾器：',
      'DELETE_FILTER':'刪除過濾器',
      'FILTER_1':'日期：',
      'BUSCAR_FILTER':'搜索',
      'TH_TITTLE':'產品歷史',
      'BTN_FILTER_HISTO':'過濾歷史',
      'TD_USUARIO':'用戶：',
      'TD_FECHA_PRODU':'產品日期：',
      'TD_TIPO_PRODU':'產品類型：',
      'TD_TIPO_USU_ADMI':'管理員用戶',
      'WARNING_NO_DATOS':'無信息顯示',
    }
  }
};
